import {TENANT_BASE_URL} from "../../../common/Config/UrlHelper";
import DatatableHelperMixin from "../../../common/Mixin/Global/DatatableHelperMixin";
import {formatDateToLocal} from "../../../common/Helper/Support/DateTimeHelper";
import HelperMixin from "../../../common/Mixin/Global/HelperMixin";
import {axiosGet} from "../../../common/Helper/AxiosHelper";

export default {
    mixins: [HelperMixin, DatatableHelperMixin],
    data() {
        return {
            options: {
                name             : this.$t('finance_categories'),
                url              : `${TENANT_BASE_URL}app/finance-categories?include_inactive=1`,
                showHeader       : true,
                showCount        : true,
                tableShadow      : false,
                tablePaddingClass: 'pt-primary',
                columns          : [
                    {
                        title    : this.$t('actions'),
                        type     : 'action',
                        key      : 'id',
                        isVisible: true
                    },
                    {
                        title    : this.$t('name'),
                        type     : 'custom-html',
                        key      : 'name',
                        isVisible: true,
                        modifier : (value) => {
                            return this.$displayByLocale(value);
                        }
                    },
                    {
                        title    : this.$t('icon'),
                        type     : 'custom-html',
                        key      : 'icon',
                        isVisible: true,
                        modifier : value => {
                            const iconName = value || 'circle';
                            return `<span class="d-inline-flex align-items-center">
                                        <i data-feather="${iconName}" class="mr-1"></i>
                                        ${this.$upperFirstLetter(iconName)}
                                    </span>`;
                        }
                    },
                    {
                        title    : this.$t('type'),
                        type     : 'custom-html',
                        key      : 'type',
                        isVisible: true,
                        modifier : value => {
                            const label = value === 'expense' ? this.$t('expense') : this.$t('income');
                            const badgeClass = value === 'expense' ? 'badge-danger' : 'badge-success';
                            return `<span class="badge badge-pill ${badgeClass}">${label}</span>`;
                        }
                    },
                    {
                        title    : this.$t('subject'),
                        type     : 'text',
                        key      : 'subject',
                        isVisible: true,
                        modifier : (value) => {
                            return value ? value : '---';
                        }
                    },
                    {
                        title    : this.$t('color'),
                        type     : 'custom-html',
                        key      : 'color',
                        isVisible: true,
                        modifier : (value) => {
                            const color = value || '#46c35f';
                            return `<span class="badge badge-pill p-2 text-white" style="background-color: ${color}">${color}</span>`;
                        }
                    },
                    {
                        title    : this.$t('status'),
                        type     : 'custom-html',
                        key      : 'active',
                        isVisible: true,
                        modifier : value => {
                            const isActive = value === 1 || value === true;
                            const label = isActive ? this.$t('active') : this.$t('inactive');
                            const badgeClass = isActive ? 'badge-success' : 'badge-secondary';
                            return `<span class="badge badge-pill ${badgeClass}">${label}</span>`;
                        }
                    },
                    {
                        title    : this.$t('remark'),
                        type     : 'custom-html',
                        key      : 'remark',
                        isVisible: true,
                        modifier : (value) => {
                            return this.$displayByLocale(value);
                        }
                    },
                    {
                        title    : this.$t('created_at'),
                        type     : 'custom-html',
                        key      : 'created_at',
                        isVisible: true,
                        modifier : (value) => {
                            return value ? formatDateToLocal(value) : '--';
                        }
                    },
                ],
                filters          : [
                    {
                        title         : this.$t('search'),
                        type          : "text",
                        key           : "search",
                        placeholder   : this.$t('search')
                    },
                    {
                        title : this.$t('type'),
                        type  : "drop-down-filter",
                        key   : "type",
                        option: [
                            { id: 'income', name: this.$t('income') },
                            { id: 'expense', name: this.$t('expense') }
                        ],
                        listValueField: 'name'
                    },
                    {
                        title : this.$t('status'),
                        type  : "drop-down-filter",
                        key   : "active",
                        option: [
                            { id: 1, name: this.$t('active') },
                            { id: 0, name: this.$t('inactive') }
                        ],
                        listValueField: 'name'
                    },
                    {
                        title : this.$t('created_at'),
                        type : "range-picker",
                        key   : "created_at",
                        option: ["today", "thisMonth", "last7Days", "thisYear"]
                    },
                ],
                paginationType   : "pagination",
                responsive       : true,
                rowLimit         : 10,
                showAction       : true,
                orderBy          : 'desc',
                actionType       : 'dropdown',
                actions          : [
                    {
                        title   : this.$t('edit'),
                        icon    : 'edit',
                        type    : 'modal',
                        modifier: row => this.$can('update_finance_categories')
                    },
                    {
                        title   : this.$t('translate'),
                        icon    : 'globe',
                        type    : 'modal',
                        modifier: row => this.$can('update_finance_categories')
                    },
                    {
                        title    : this.$t('delete'),
                        icon     : 'trash-2',
                        type     : 'modal',
                        component: 'app-confirmation-modal',
                        modalId  : 'app-confirmation-modal',
                        url      : `${TENANT_BASE_URL}app/finance-categories/`,
                        name     : 'delete',
                        modifier : row => this.$can('delete_finance_categories')
                    }
                ],
            }
        }
    },
    mounted() {
        // Load options
    },
}
